import useUserSettings from "@/composables/useUserSettings";

const { getUserSetting } = useUserSettings();

export default {
    namespaced: true,
    state: {
        notifyConversationUnassigned: getUserSetting("notifyConversationUnassigned", "0"), // Nieuwe inkomende conversaties in 'Nieuw'
        notifyConversationAssigned: getUserSetting("notifyConversationAssigned", "0"), // Wanneer een conversatie aan mij wordt toegewezen
        notifyIncomingMessage: getUserSetting("notifyIncomingMessage", "0"), // Nieuwe reactie op een aan mij toegewezen conversatie
        notifyIncomingMessageNew: getUserSetting("notifyIncomingMessageNew", "0"), // Elke nieuwe reactie van conversaties in 'Nieuw'
        notifyTeamchatStarted: getUserSetting("notifyTeamchatStarted", "0"),
        notifyTeamchatMessage: getUserSetting("notifyTeamchatMessage", "0"),
    },
    getters: {},
    mutations: {
        UPDATE_NOTIFY_CONVERSATION_UNASSIGNED(state, val) {
            state.notifyConversationUnassigned = val;
        },
        UPDATE_NOTIFY_CONVERSATION_ASSIGNED(state, val) {
            state.notifyConversationAssigned = val;
        },
        UPDATE_NOTIFY_INCOMING_MESSAGE(state, val) {
            state.notifyIncomingMessage = val;
        },
        UPDATE_NOTIFY_INCOMING_MESSAGE_NEW(state, val) {
            state.notifyIncomingMessageNew = val;
        },
        UPDATE_NOTIFY_TEAMCHAT_STARTED(state, val) {
            state.notifyTeamchatStarted = val;
        },
        UPDATE_NOTIFY_TEAMCHAT_MESSAGE(state, val) {
            state.notifyTeamchatMessage = val;
        },
    },
};
